export default __webpack_public_path__ + "static/communities-1M-cf799aa71c9a8836d07ecc50419c2485.jpg";